import { useEffect, useRef } from 'react';

export const useLoadMore = (loadMore?: () => void) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current === null) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          loadMore?.();
        }
      },
      {
        // Root is the viewport
        root: null,
        threshold: 1.0,
      }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, loadMore]);

  return ref;
};
